<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">線上點餐管理 / POS商品管理</b-col>
      <b-col>
        <div class="text-right">
        </div>
      </b-col>
    </b-row>

    <div id="func-content">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row">
                  <label class="control-label col-md-2">商品：</label>
                  <div class="col-md-4">
                    <input
                      type="text"
                      class="form-control"
                      v-model="search.name"
                      placeholder="請輸入關鍵字搜尋"
                    />
                  </div>
                    <label class="control-label col-md-2">品牌：</label>
                    <div class="col-md-4">
                      <select
                        id="queryBrandsCode"
                        name="queryBrandsCode"
                        class="form-control"
                        v-model="search.queryBrandsCode"
                        @change="querySelectListData()"
                      >
                      <option
                        v-for="x in selectListBrands"
                        v-bind:value="x.Code"
                        :key="x.Code"
                      >{{x.Text}}</option>
                      </select>
                    </div>
                  </div>
                <div class="row mt-3">
                  <label class="control-label col-md-2">POS分類：</label>
                  <div class="col-md-4">
                    <select
                      id="queryAttributesCode"
                      name="queryAttributesCode"
                      class="form-control"
                      v-model="search.queryAttributesCode"
                    >
                      <option value>全部</option>
                      <option
                        v-for="x in selectListPosType"
                        v-bind:value="x.Code"
                        :key="x.Code"
                      >{{x.Name}}</option>
                    </select>
                  </div>
                  <div class="col-md-3">
                    <button type="button" class="btn btn-ptc1" @click="btnQuery">查詢</button>
                    <button type="button" class="btn btn-ptc1" @click="reset">重設</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      <b-card class="bg-default-card">
        <div class="text-right">
          <button class="btn btn-ptc1" @click="queryPosSynInfo()" v-if="FunctionPermission > 1" >POS資料同步</button>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-6">
                <h3></h3>
              </div>
              <div class="col-lg-12 mt-2">
                <div class="table-responsive">
                  <table class="table table-bordred table-striped">
                    <thead>
                      <tr>
                        <th>項次</th>
                        <th>POS分類</th>
                        <th>品號</th>
                        <th>品名</th>
                        <th>圖片</th>
                        <th>調味項目</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(x,index) in items" :key="x.Code">
                        <td>{{search.pageRows * (search.currentPage - 1) + index + 1}}</td>
                        <td>{{x.Product.AttributeName}}</td>
                        <td>{{x.Product.Code}}</td>
                        <td>{{x.Product.Name}}</td>
                        <td>
                          <img height="140px" :src="x.Product.ImageURL" />
                        </td>
                        <td
                          v-if="x.ProductFlavorList"
                        >{{x.ProductFlavorList.map(function(y){return y.ProductFlavor.Name}).join(',')}}</td>
                        <td v-else>無</td>
                        <td>
                          <router-link
                            v-b-tooltip.hover.top
                            title="編輯"
                            class="btn-circle btn-circle-ptc1"
                            tag="button"
                            :to="{ name: 'product_edit', params: { item: x, action: 1, search: search} }"
                            v-if="FunctionPermission > 1"
                          >
                            <span class="fa fa-pencil-alt"></span>
                          </router-link>
                          <button
                            v-b-tooltip.hover.top
                            title="預覽"
                            class="btn-circle btn-circle-ptc1"
                            @click="showDetail(x)"
                          >
                            <span class="fa fa-search-plus"></span>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="row" style="padding: 0 1rem">
                  <b-pagination
                    size="md"
                    :total-rows="search.totalRows"
                    v-model="search.currentPage"
                    :per-page="search.pageRows"
                    @change="changePage"
                  ></b-pagination>
                  <label style="margin:8px">{{search.startRowNum}}到{{search.endRowNum}}，總共 {{search.totalRows}}筆</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>

      <!-- 預覽畫面Modal -->
      <b-modal ref="mdDetail" hide-footer size="lg" title="商品明細">
        <b-container fluid>
          <div class="row">
            <div class="col-lg-7">
              <div class="row mb-3">
                <label class="control-label col-md-3">POS分類：</label>
                <div class="col-md-7">{{md_item.md_AttributeName}}</div>
              </div>
              <div class="row mb-3">
                <label class="control-label col-md-3">品號：</label>
                <div class="col-md-7">{{md_item.md_Code}}</div>
              </div>
              <div class="row mb-3">
                <label class="control-label col-md-3">品名：</label>
                <div class="col-md-7">{{md_item.md_Name}}</div>
              </div>
              <div class="row mb-3">
                <table class="table table-bordred table-striped">
                  <thead>
                    <tr>
                      <th>調味</th>
                      <th>必選</th>
                      <th>項目</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(x, index) in md_item.md_Flavors" :key="index">
                      <td>{{x.Flavor}}</td>
                      <td>
                        <div v-if="x.IsRequired">是</div>
                        <div v-else>否</div>
                      </td>
                      <td>{{x.FlavorItems}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-lg-5">
              <img class="bk_img" :src="md_item.md_imgUrl" />
            </div>
          </div>
        </b-container>
      </b-modal>

      <!-- POS同步 訊息 Modal -->
      <b-modal ref="mdPosSyn" hide-footer title="POS資料同步(全品牌)">
        <b-container fluid>
          <form>
            <div class="row mb-3">
                <label class="control-label col-md-12">上次更新時間：{{mdPosSynInfo.FinalAt |formatFullDate}}</label>
                <div class="control-label col-md-12" v-if="mdPosSynInfo.ProcessValue <100" >同步處理中，您可先暫時關閉此視窗進行其他作業。</div>
            </div>
              <div class="float-right">
                <b-btn variant="primary" v-if="mdPosSynInfo.ProcessValue >=100" @click="isSysData()">同步</b-btn>
                <b-btn variant="secondary" @click="cancelSys()">關閉</b-btn>
              </div>
          </form>
        </b-container>
      </b-modal>

    </div>
  </div>
</template>

<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js"></script>
<script src="//cdn.jsdelivr.net/npm/sortablejs@1.7.0/Sortable.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/Vue.Draggable/2.15.0/vuedraggable.min.js"></script>

// <script>
import { getFunctionPermission } from "../../../js/LoginUserFunction.js";
import { API_URL } from "../../../store/root";
import miniToastr from "mini-toastr";
import draggable from "vuedraggable";
import VModal from "vue-js-modal";
import axios from "axios";
miniToastr.init();
export default {
  components: {
    draggable
  },
  data() {
    return {
      search: {
        name: "",
        queryAttributesCode: "0",
        queryBrandsCode: "MWD",
        currentPage: 1,
        totalRows: 0,
        pageRows: 20,
        startRowNum: 0,
        endRowNum: 0,
      },
      API_URL: API_URL,
      selectListPosType: [], // Pos分類下拉選單
      selectListBrands: [], // 品牌下拉選單
      items: [],
      md_item: {
        md_AttributeName: "",
        md_Code: "",
        md_Name: "",
        md_imgUrl: undefined,
        md_Flavors: []
      },
      mdPosSynInfo: {}
    };
  },
  created() {
    this.FunctionPermission = getFunctionPermission("F16"); // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: "name" });
      return;
    }

    this.querySelectListData();
    this.querySelectListBrands();

    var paramsSearch = this.$route.params.search;
    if (paramsSearch !== undefined) {
        this.search = paramsSearch;
        this.query()
    } else {
      this.reset();
    }
  },
  methods: {
    reset() {
      this.search.name = "";
      this.search.queryAttributesCode = "";
      this.search.currentPage = 1;
      this.search.queryBrandsCode= "MWD";

      this.query();
    },
    btnQuery() {
      this.search.currentPage = 1;
      this.query();
    },
    query() {
      var name, attributesCode, status, appShow, page, pageRows;
      status = 1;
      name = this.search.name;
      attributesCode = this.search.queryAttributesCode;
      appShow = this.search.queryAppShow;
      page = this.search.currentPage;
      pageRows = this.search.pageRows;
      this.$parent.Loading = true;

      return axios
        .post(API_URL + "/web/shopping/getallproductList/v1", {
          Status: status,
          Name: name,
          AttributesCode: attributesCode,
          BrandCode: this.search.queryBrandsCode,
          page: page,
          pageRows: pageRows
        })
        .then(response => {
          // console.log(response.data)
          this.$store.commit("TOKEN", response.data.jwt);
          this.$parent.Loading = false;

          if (response.data.result === "0000") {
            this.search.totalRows =
              response.data.count === undefined ? 0 : response.data.count;
            this.items = response.data.data;
            this.search.startRowNum =
              response.data.count === undefined || response.data.count === 0
                ? 0
                : this.search.pageRows * (this.search.currentPage - 1) + 1;
            this.search.endRowNum =
              response.data.count === undefined || response.data.count === 0
                ? 0
                : this.search.pageRows > response.data.count
                ? response.data.count
                : this.search.currentPage * this.search.pageRows >= response.data.count
                ? response.data.count
                : this.search.currentPage * this.search.pageRows;

          } else if (response.data.result === "0006") {
            this.$parent.logOut(true, true);
          } else {
            this.items = [];
            miniToastr.error(response.data.message, "資料讀取異常");
            console.log(response.data.message);
          }
        })
        .catch(error => {
          this.items = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
    querySelectListData() {
      //Pos分類
      axios
        .post(API_URL + "/web/shopping/getallproductAttributes/v1", {
          status: 0,
          brandCode: this.search.queryBrandsCode,
        })
        .then(response => {
          this.selectListPosType = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListPosType = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: true
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
    changePage(page) {
      this.search.currentPage = page;
      this.query();
    },
    showDetail(item) {
      this.md_item.md_AttributeName = item.Product.AttributeName;
      this.md_item.md_Code = item.Product.Code;
      this.md_item.md_Name = item.Product.Name;
      this.md_item.md_imgUrl = item.Product.ImageURL;
      this.md_item.md_Flavors = [];
      if (item.ProductFlavorList) {
        item.ProductFlavorList.forEach(x => {
          this.md_item.md_Flavors.push({
            Flavor: x.ProductFlavor.Name,
            IsRequired: x.ProductFlavor.IsRequired,
            FlavorItems: x.ProductFlavorItemJSON
          });
        });
      }
      this.$refs.mdDetail.show();
    },
    queryPosSynInfo() {
      return axios
        .post(API_URL + "/web/shopping/PosMasterFileSyn/v1",{IsSyn:false})
        .then(response => {
          this.$store.commit("TOKEN", response.data.jwt);
          this.$parent.Loading = false;

          if (response.data.result === "0000") {
            this.mdPosSynInfo = response.data.data;
            this.$refs.mdPosSyn.show();
          } else if (response.data.result === "0006") {
            this.$parent.logOut(true, true);
          } else {
            miniToastr.error(response.data.message, "資料讀取異常");
            console.log(response.data.message);
          }
        })
        .catch(error => {
          this.items = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
    isSysData(){
    return axios
        .post(API_URL + "/web/shopping/PosMasterFileSyn/v1",{IsSyn:true})
        .then(response => {
          this.$store.commit("TOKEN", response.data.jwt);
          this.$parent.Loading = false;

          if (response.data.result === "0000") {
            this.mdPosSynInfo = response.data.data;
            this.$refs.mdPosSyn.show();
          } else if (response.data.result === "0006") {
            this.$parent.logOut(true, true);
          } else {
            miniToastr.error(response.data.message, "資料讀取異常");
            console.log(response.data.message);
          }
        })
        .catch(error => {
          this.items = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
    cancelSys(){
       this.$refs.mdPosSyn.hide()
    }
  },
  filters: {
    formatDate: function(date) {
      var d = new Date(date);
      var year = d.getFullYear();
      var mon =
        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      var day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      return year + "/" + mon + "/" + day;
    },
    formatFullDate: function(date) {
      var d = new Date(date);
      var year = d.getFullYear();
      var mon =
        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      var day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      var hour = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      var min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      var sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      return year + "/" + mon + "/" + day + " " + hour + ":" + min + ":" + sec;
    }
  }
};
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
.table-move > tbody > tr {
  cursor: move;
}
.block {
  text-align: center;
  height: 454pt;
}
.front_img {
  height: 450pt;
  position: relative;
  z-index: 1;
}
.bk_div {
  top: 53pt;
  left: 79pt;
  width: 196pt;
  height: 344pt;
  position: absolute;
  z-index: 0;
}
.bk_img {
  width: 320px;
  height: 240px;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/product/List.vue